import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { IServerError } from 'js/hooks/socket/types';
import { ITranslateMethod } from 'js/hooks/i18n/types';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const useGetErrorMessage = ({
    tkPrefix,
    translate: customTranslate
}: {
    tkPrefix?: string;
    translate?: ITranslateMethod;
} = {}) => {
    const componentTranslate = useComponentTranslations();
    const translateWithCustomTK = useTranslations(tkPrefix);
    const translate = customTranslate || tkPrefix && translateWithCustomTK || componentTranslate;

    return useCallback((error: unknown, defaultMessage?: string): string => {
        const systemError = translate('playtech.mobile.system.systemError', 'System error');

        if (error && typeof error === 'object' && !Array.isArray(error)) {
            const {
                actions,
                errorCode,
                errorText,
                userErrors,
                errorMessage,
                playerMessage
            } = (error as IServerError).data || (error as { response: IServerError })?.response?.data || {};

            const userError = Array.isArray(userErrors)
                ? userErrors?.[0]?.message
                : userErrors?.UserError?.[0]?.message;
            const actionMessage = actions?.PlayerActionShowMessage?.[0]?.message;
            const spareMessage = playerMessage
                || errorMessage
                || errorText
                || defaultMessage;

            return userError
                || actionMessage
                || translate(`error.${errorCode}`, spareMessage ?? systemError);
        }

        return systemError;
    }, [translate]);
};
